import Joi from "joi";
import FormValidationResult from "../../../../../../common/utils/validation/types/form-validation-result";
import formValidationService from "../../../../../../common/utils/validation/form-validation.service";

const validateActivity = (value: boolean | null): FormValidationResult => {
  const validationSchema = Joi.boolean().invalid(null).required();

  return formValidationService.validate(value, validationSchema);
};

const validateNotes = (value: string): FormValidationResult => {
  const validationSchema = Joi.string().allow("").max(1024);

  return formValidationService.validate(value, validationSchema);
};

const driverContractEditFormValidationService = {
  validateActivity,
  validateNotes,
};

export default driverContractEditFormValidationService;
